<template>
    <b-card>
        <div slot="header">
          <i class="fa fa-history" aria-hidden="true"></i>
            {{text.history}}
        </div>
        <b-row>
            <b-col sm="12">
                <alert-fail :show="errorMessage !== ''"> {{ errorMessage }} </alert-fail>
                <b-row>
                    <b-col>
                        <b-form-group
                        label-cols-sm="3"
                        label-cols-lg="2"
                        label="Filter"
                        >
                        <b-form-input size="sm" placeholder="Filter username or fullname."></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-row>
                            <b-col md="6"><v-select class="users-filter" :options="actionList" :placeholder="'filter action'"></v-select></b-col>
                            <b-col md="6"><v-select class="users-filter filter-status" :placeholder="'filter time'"></v-select></b-col>
                        </b-row>
                    </b-col>
                </b-row>

                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="pagination.currentPage"
                          :per-page="pagination.numberPerPage"
                          class=""
                          tbody-class="tbody" hover
                          thead-tr-class="thead"
                          @row-clicked="viewDetails"
                          selectable
                          selectedVariant="single"
                          :fields="fields"
                          :items="list">
                          <!-- <template slot="thumbnail" slot-scope="row">
                            <img class="thumbnail" :src="row.item.thumbnail" alt="Thumbnail">
                          </template> -->
                          <template slot="status" slot-scope="row">
                            <font v-if="'suspend' == row.item.status" class="red">Suspend</font>
                            <font v-else class="green">Active</font>
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                    <b-col>
                        <app-paging
                            :totalRows="pagination.totalRows"
                            :page="pagination.currentPage"
                            @changePage="changePage"/>
                    </b-col>
                    </b-row>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import AlertFail from '../../components/alert/AlertFail';
import AppPaging from '../../components/Pagination.vue';
import vSelect from 'vue-select';
import { textUser } from '@/assets/utils/language';

export default {
  data () {
    return {
      errorMessage: '',
      isBusy: false,
      pagination: {
        currentPage: 1,
        numberPerPage: process.env.VUE_APP_NUMBER_PER_PAGE,
        toalRows: 40
      },
      fields: [
        { key: 'user' },
        { key: 'action' },
        { key: 'object' },
        { key: 'time' }
      ],
      list: [
        { user: 'admin', action: 'create', object: 'user', time: '11/07/2019 20:11:01' },
        { user: 'admin', action: 'create', object: 'user', time: '11/07/2019 20:11:11' },
        { user: 'admin', action: 'delete', object: 'permission', time: '11/07/2019 20:11:22' },
        { user: 'admin2', action: 'update', object: 'user', time: '11/07/2019 20:11:22' }
      ],
      actionList: [
        'create user', 'update user', 'delete user', 'create permission', 'delete permission'
      ],
      text: {}
    };
  },
  methods: {
    viewDetails () {
      console.log('view details');
    },
    changePage () {
      console.log('change page');
    }
  },
  watch: {
    $language: function () {
      this.text = textUser(this.$language);
    }
  },
  mounted () {
    this.text = textUser(this.$language);
  },
  components: {
    AppPaging,
    'v-select': vSelect,
    AlertFail
  }
};
</script>
